import styled, { keyframes, css } from "styled-components"

export const ProjectsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px 20px;
    align-items: center;
`

export const ProjectsHeader = styled.h1`
    padding: 20px;
    border-bottom: 3px solid #3b82f6;
    align-self: center;
    color: #1f2937;
    text-align: center;
    position: relative;
`

export const Project = styled.div`
    width: 100%;
    max-width: 600px;
    height: 400px;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    padding: 20px;
    gap: 20px;
    
    
    @media(max-width: 1150px) {
        width: 100%;
        height: 100%;
        flex-direction: column;
        padding: 15px;
    }
`

export const ProjectImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 12px 12px 0 0;

    &:hover .preview-text {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.05);
    }

    @media (max-width: 480px) {
        height: 45%;
    }
`

export const PreviewText = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.9), rgba(37, 99, 235, 0.9));
    padding: 12px 24px;
    border-radius: 25px;
    font-size: 1.2rem;
    font-weight: 600;
    pointer-events: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 32px rgba(59, 130, 246, 0.3);
`

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    } to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
`

export const ProjectImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    

    &:hover {
        filter: brightness(0.6) blur(1px);
        transform: scale(1.08);
    }
`

export const ProjectCard = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 100%;
    height: 100%;
    background: white;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(59, 130, 246, 0.1);
    animation: ${({ $isVisible }) => $isVisible ? css`${fadeIn} 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards` : 'none'};
    opacity: ${({ $isVisible }) => $isVisible ? 1 : 0};
    transform: ${({ $isVisible }) => $isVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)'};
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
        transform: translateY(-8px) scale(1.02);
        box-shadow: 0 24px 80px rgba(59, 130, 246, 0.25);
    }

    @media(max-width: 650px) {
        wdith: 90%;
    }
`

export const ProjectInfo = styled.div`
    padding: 15px 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;

    @media (max-width: 480px) {
        padding: 12px 15px;
        gap: 8px;
    }
`

export const ProjectTitle = styled.h3`
    font-family: 'Space Grotesk', sans-serif;
    font-size: 1.4rem;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    text-align: center;

    @media (max-width: 480px) {
        font-size: 1.2rem;
    }
`

export const ProjectDate = styled.p`
    font-size: 0.9rem;
    color: #6b7280;
    margin: 0;
    text-align: center;
    font-weight: 500;

    @media (max-width: 480px) {
        font-size: 0.8rem;
    }
`

export const SkillsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: center;
    margin-top: 8px;

    @media (max-width: 480px) {
        gap: 4px;
        margin-top: 6px;
    }
`

export const SkillTag = styled.span.withConfig({
    shouldForwardProp: (prop) => prop !== 'isMobile'
})`
    background: linear-gradient(135deg, #f1f5f9, #e2e8f0);
    color: #374151;
    padding: ${props => props.isMobile ? '8px' : '5px 10px'};
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 500;
    border: 1px solid rgba(59, 130, 246, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: default;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: ${props => props.isMobile ? '40px' : 'auto'};
    justify-content: center;
    cursor: pointer;


    .skill-text {
        font-size: 0.75rem;
        font-weight: 500;
    }

    &:hover {
        background: linear-gradient(135deg, #3b82f6, #2563eb);
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
        
        .skill-icon {
            color: white;
            fill: currentColor;
        }
        
        .skill-text {
            color: white;
        }
    }

    @media (max-width: 480px) {
        padding: 8px;
        min-width: 36px;
        
        .skill-icon {
            width: 1rem;
            height: 1rem;
        }
    }
`

export const ProjectButtonContainer = styled.div`
    padding: 0 20px 20px 20px;
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        gap: 12px;
        padding: 0 15px 15px 15px;
    }

    @media (max-width: 480px) {
        padding: 0 10px 25px 10px;
        gap: 8px;
        justify-content: center;
        
        & > * {
            width: 60px;
            height: 60px;
            min-width: 60px;
            border-radius: 50%;
            justify-content: center;
            align-items: center;
            display: flex;
            font-size: 1.5rem;
        }
    }
`

export const ProjectGithubButton = styled.button`
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    color: white;
    border: none;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    display: flex;
    alignItems: center;
    gap: 8px;
    padding: 10px 25px;
    border-radius: 25px;

    &:hover{
        transform: scale(1.05);
    }

    @media(max-width: 1025px) {
        padding: 10px 15px;
        border-radius: 50%;    
    }
`